import React from 'react';
import Icon from '../../../components/AppIcon';

const SafetySection = () => {
  const safetyFeatures = [
    {
      icon: 'ShieldCheck',
      title: 'Verified Partners Only',
      description: 'All hotels, restaurants, and services are personally vetted and verified by our team.',
      bgColor: 'bg-green-500',
      iconColor: 'text-white',
    },
    {
      icon: 'CreditCard',
      title: 'Fair Pricing Guarantee',
      description: 'No overcharging! All prices are standardized and transparent. Pay what locals pay.',
      bgColor: 'bg-blue-500',
      iconColor: 'text-white',
    },
    {
      icon: 'Phone',
      title: '24/7 Tourist Hotline',
      description: 'Emergency support available round the clock. We\'re always here to help.',
      bgColor: 'bg-red-500',
      iconColor: 'text-white',
    },
    {
      icon: 'MapPin',
      title: 'Safe Route Navigation',
      description: 'Recommended routes and areas verified for tourist safety and accessibility.',
      bgColor: 'bg-purple-500',
      iconColor: 'text-white',
    },
    {
      icon: 'CheckCircle',
      title: 'Licensed Operators',
      description: 'All transport and tour operators are DOT-accredited and fully insured.',
      bgColor: 'bg-teal-500',
      iconColor: 'text-white',
    },
    {
      icon: 'Users',
      title: 'Community Verified',
      description: 'Real reviews from verified travelers. No fake reviews, only genuine experiences.',
      bgColor: 'bg-orange-500',
      iconColor: 'text-white',
    },
  ];

  return (
    <section className="py-5 md:py-8 lg:py-10 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-3 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-3 md:mb-6">
          <div className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-green-100 rounded-full mb-1.5 md:mb-2">
            <Icon name="Shield" size={10} className="text-green-600" />
            <span className="text-[9px] md:text-xs font-semibold text-green-700">Your Safety, Our Priority</span>
          </div>
          <h2 className="text-base md:text-2xl lg:text-3xl font-bold text-gray-900 mb-1.5 md:mb-2">
            Travel with Confidence
          </h2>
          <p className="text-[9px] md:text-sm text-gray-600 max-w-2xl mx-auto">
            We've built multiple layers of protection to ensure your Philippine adventure is safe, fair-priced, and worry-free.
          </p>
        </div>

        {/* Safety Features Grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-1.5 md:gap-4">
          {safetyFeatures?.map((feature, index) => (
            <div
              key={index}
              className="group p-1.5 md:p-2.5 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="flex flex-col items-center gap-1 md:gap-1.5">
                <div
                  className={`w-7 h-7 md:w-10 md:h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110 ${feature?.bgColor}`}
                >
                  <Icon name={feature?.icon} size={14} className={feature?.iconColor} />
                </div>
                <div className="flex-1 text-center">
                  <h3 className="text-[9px] md:text-xs font-bold text-gray-900 mb-0.5 md:mb-1 break-words">
                    {feature?.title}
                  </h3>
                  <p className="text-[7px] md:text-[9px] text-gray-600 break-words">
                    {feature?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SafetySection;